<template>
  <div class="solutionsBox">
    <nav class="nav">
      <!-- 左侧按钮 -->
      <div
        class="iconLeft"
        :style="startIndex == 0 ? 'color:#CCCCCC' : 'color:#3e79fe;'"
        style="position: absolute; left: 50px; top: 50%"
        @click="tabLeft"
      >
        <i class="el-icon-arrow-left fontS" />
      </div>
      <!-- 右侧按钮 -->
      <div
        class="iconRight"
        :style="
          endIndex == tabsList.length - 1 ? 'color:#CCCCCC' : 'color:#3e79fe;'
        "
        style="position: absolute; right: 50px; top: 50%"
        @click="tabRight"
      >
        <i class="el-icon-arrow-right fontS" />
      </div>
      <!-- 中间内容 -->
      <div id="box" class="box">
        <div
          class="good_city"
          :style="'transform: translateX(' + tabIndex + 'px);'"
        >
          <div class="tabsBox">
            <div
              v-for="(item, index) in tabsList"
              :id="'tab' + item.id"
              :key="item.label"
              class="tab"
              @click="clickTab(item, index)"
            >
              <!-- :class="tabClick == item.id ? 'tabClick' : ''" -->
              <img class="imgBox" :src="item.img" alt="" />
              {{ item.value }}
              <div :class="{ active: index == currentActive }"></div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="contentBox">
      <span class="conTitle">{{ currentTitle }}</span>
      <div
        class="contentItemBox"
        v-for="(item, index) in solutionList"
        :key="index"
        @click="toMore(item)"
      >
        <img class="imgBox" :src="item.img" alt="" />
        <div class="conItem">
          <h3 class="conItemTitle">{{ item.title }}</h3>
          <p class="conItemText">{{ item.content }}</p>
          <div class="more">
            READ MORE<i class="el-icon-arrow-right fontS"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { solutionObj } from '@/static/solution.js'
export default {
  data () {
    return {
      currentActive: 0,
      currentTitle: 'Solution One',
      tabClick: 0, // 选择的tab
      tabIndex: 0, // tab需要移动的宽
      startIndex: 0, // display展示的起始div索引
      endIndex: 0, // display展示的终止div索引
      tabsList: [
        {
          id: 1,
          label: '1',
          value: 'Solutions one',
          img: require('@/assets/logo.png')
        },
        {
          id: 2,
          label: '2',
          value: 'Solutions two',
          img: require('@/assets/logo.png')
        },
        {
          id: 3,
          label: '3',
          value: 'Solutions three',
          img: require('@/assets/logo.png')
        },
        {
          id: 4,
          label: '4',
          value: 'Solutions four',
          img: require('@/assets/logo.png')
        },
        {
          id: 5,
          label: '5',
          value: '央广网',
          img: require('@/assets/logo.png')
        },
        {
          id: 6,
          label: '6',
          value: '央广网2',
          img: require('@/assets/logo.png')
        }
      ],
      solutionList: []
    }
  },
  mounted () {
    this.getTabWidth()
    this.setDisplayTab(0)
  },
  methods: {
    toMore (item) {
      this.$router.push({
        path: '/solutionsDetail',
        query: {
          id: item.id
        }
      })
    },
    getTabWidth () {
      this.tabsList.forEach((item, index) => {
        this.tabsList[index].width = document.getElementById(
          'tab' + item.id
        ).clientWidth
      })
      // console.log(this.tabsList)
    },
    setDisplayTab (inx) {
      // 参数：起始索引
      // 当前展示起始索引startIndex，box宽度，计算<box的索引endIndex，start-end展示，其他隐藏
      // 可展示区域宽度 -- 即box div宽度
      this.fatherWidth = document.getElementById('box').clientWidth
      let sumWidth = 0
      this.tabsList.forEach((item, index) => {
        if (index >= inx) {
          sumWidth = sumWidth + item.width + 90
          // this.endIndex = index;
          if (this.fatherWidth >= sumWidth) {
            document.getElementById('tab' + item.id).style.display = 'flex'
            // 'inline-block'
            this.endIndex = index
          } else {
            document.getElementById('tab' + item.id).style.display = 'none'
          }
        }
      })
    },
    clickTab (item, index) {
      this.currentTitle = item.value
      this.currentActive = index
      this.solutionList = solutionObj[index + 1]
      // this.indexBefore = 0 // 之前选中的div
      // this.indexNow = 0 // 当前选中的div
      // // this.tabidnow = 0; // 需要移动的宽
      // this.tabsList.forEach((item, index) => {
      //   if (item.id === this.tabClick) {
      //     this.indexBefore = index
      //   }
      //   if (it.id === item.id) {
      //     this.indexNow = index
      //   }
      // })
      // this.tabClick = it.id
    },
    tabLeft () {
      // 移动距离tabindex=startIndex-1的宽度，调用setDisplayTab控制显隐
      // 判断是否为初始位置
      if (this.startIndex !== 0) {
        // 向左移动，起始位置-1
        this.startIndex--
        this.setDisplayTab(this.startIndex)
        this.tabIndex += this.tabsList[this.startIndex].width + 90
      }
    },
    tabRight () {
      if (this.endIndex < this.tabsList.length - 1) {
        const tabStartBeforeIndex = this.startIndex
        this.startIndex++
        this.setDisplayTab(this.startIndex)
        this.tabIndex -= this.tabsList[tabStartBeforeIndex].width + 90
      }
    }
  },
  watch: {
    $route: {
      handler: function (newVal) {
        let number = newVal.query.num
        this.solutionList = solutionObj[number]
        if (number == 1) {
          this.currentTitle = 'Solutions one'
        } else if (number == 2) {
          this.currentTitle = 'Solutions two'
        } else if (number == 3) {
          this.currentTitle = 'Solutions three'
        } else if (number == 4) {
          this.currentTitle = 'Solutions four'
        }
        this.currentActive = newVal.query.num * 1 - 1
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.solutionsBox {
  .nav {
    width: 100%;
    height: 300px;
    background-color: #d7d7d7;
    position: relative;
    .iconLeft {
      text-align: center;
      padding: 8px;
      cursor: pointer;
      // background-color: white;
      transform: translateY(-50%);
      z-index: 999;
      .fontS {
        font-size: 50px;
        color: #555555;
        font-weight: 700;
      }
    }
    .iconRight {
      text-align: center;
      padding: 8px;
      cursor: pointer;
      // background-color: white;
      transform: translateY(-50%);
      z-index: 999;
      .fontS {
        font-size: 50px;
        color: #555555;
        font-weight: 700;
      }
    }
    .box {
      height: 300px;
      margin: 0 100px;
      overflow: hidden;

      .good_city {
        width: 9999px; //这里其实不应该写死 应该写成动态赋值 这里我就先写死
        height: 300px;
        transition: all 0.5s;
      }
      .tabsBox {
        width: 9999px;
        height: 300px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        overflow: hidden;
        align-items: center;
        .tab {
          height: 230px;
          width: 230px;
          margin: 0 50px;
          cursor: pointer;
          background: #fff;
          border-radius: 10px;
          // justify-content: space-evenly;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
          .imgBox {
            width: 100px;
            height: 100px;
            margin-bottom: 10px;
          }
          .active {
            position: absolute;
            bottom: 15px;
            width: 150px;
            height: 5px;
            background-color: #3e79fe;
          }
        }
        .tabClick {
          background: #3e79fe;
          color: #ffffff;
        }
      }
    }
  }
  .contentBox {
    padding: 20px 40px;
    .conTitle {
      font-size: 30px;
      font-weight: 700;
      border-bottom: 2px solid #000;
      padding-bottom: 10px;
    }
    .contentItemBox {
      margin: 20px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      .imgBox {
        width: 400px;
        height: 300px;
      }
      .conItem {
        padding: 20px;
        border: 1px solid #000;
        border-left: none;
        .conItemTitle {
          font-size: 28px;
        }
        .conItemText {
          font-size: 22px;
          margin: 20px 0;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          // height: 60px;
          // max-height: 60px;
          -webkit-line-clamp: 5;
          text-overflow: ellipsis;
        }
        .more {
          font-size: 20px;
          font-weight: 700;
          color: #7f7f7f;
          .fontS {
            font-size: 22px;
            color: #7f7f7f;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
